import DOMPurify from 'dompurify';

const DEFAULT_SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'a',
    'abbr',
    'b',
    'blockquote',
    'br',
    'code',
    'div',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'i',
    'img',
    'li',
    'ol',
    'p',
    'pre',
    'span',
    'strong',
    'u',
    'ul',
  ],
  ALLOWED_ATTR: [
    'alt',
    'class',
    'href',
    'rel',
    'src',
    'style',
    'target',
    'title',
  ],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus'],
};

export const sanitizeHtml = (rawHtml) => {
  const html = String(rawHtml || '');
  return DOMPurify.sanitize(html, DEFAULT_SANITIZE_CONFIG);
};

export default sanitizeHtml;
